export default "/assets/images/wildfire-smoke-video-thumbnail.jpg?4fea312af1757ef2cf67c0efb0510177";